import React from "react";

const NoteSolidIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
    >
      <g clipPath="url(#clip0_1769_7267)">
        <path
          d="M25.9166 4.97956L23.0389 2.10178C22.7915 1.86594 22.4629 1.73438 22.1211 1.73438C21.7793 1.73438 21.4507 1.86594 21.2033 2.10178L18.6444 4.66845H4.91664C4.50408 4.66845 4.10842 4.83234 3.8167 5.12406C3.52497 5.41578 3.36108 5.81145 3.36108 6.224L3.36108 23.3351C3.36108 23.7477 3.52497 24.1433 3.8167 24.4351C4.10842 24.7268 4.50408 24.8907 4.91664 24.8907H22.0278C22.4403 24.8907 22.836 24.7268 23.1277 24.4351C23.4194 24.1433 23.5833 23.7477 23.5833 23.3351V9.14845L25.9166 6.81512C26.1598 6.57158 26.2964 6.24149 26.2964 5.89734C26.2964 5.55318 26.1598 5.22309 25.9166 4.97956ZM14.8955 15.6584L11.6366 16.3818L12.4144 13.154L19.8422 5.71067L22.3544 8.22289L14.8955 15.6584ZM23.1944 7.33623L20.6822 4.824L22.1211 3.38512L24.6333 5.89734L23.1944 7.33623Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1769_7267">
          <rect
            width="28"
            height="28"
            fill="white"
            transform="translate(0.25)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NoteSolidIcon;
